import {classNames, React, observer} from '@api'
import {Position} from '@blueprintjs/core'
import {SeasonSelectorFilterDropdownModal, SeasonSelectorFilterHierarchyDropdownModal} from '@modules'
import {useStores} from '@modules'
import * as css from './ModalCatalogItemSeasonSelectors.css'

export const ModalCatalogItemSeasonSelectors = observer<{ className?: string, position?: Position}>(({className, position}) => {
  const {catalog: {hasLoadedConfig, _fieldByName, showHierarchyDropDown, hasHierarchyItem, nonHierarchyItems}} = useStores()

  return hasLoadedConfig && showHierarchyDropDown === true && (
    <div className={classNames(css.root, className)}>
      {hasHierarchyItem && <SeasonSelectorFilterHierarchyDropdownModal position={position}/>}
      {nonHierarchyItems.map(({field: f}) => {
        return <SeasonSelectorFilterDropdownModal field={_fieldByName[f] ?? {field: f}} key={f} />
      })}
  </div>)
})




// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/ModalCatalogItemSeasonSelectors.tsx